module.exports = __webpack_public_path__ + "img/order.757501dd.svg";